import { GlobalStyle } from '../../types/Config';
import { tokens } from '../../styles/tokens';

const { color } = tokens;

/**
 * MUI-facing colour roles, every one resolved from the design tokens so the
 * theme and the SCSS modules share a single palette.
 */
export const colors: GlobalStyle = {
  textColor: color.text,
  textSubtitleColor: color.textMuted,
  backgroundColor: color.neutral100,
  inputFocusColor: color.brandPrimary,
  inputBorderColor: color.blue400,
  inputLabelColor: color.textSecondary,
  inputPlaceholderColor: color.textMuted,
  inputErrorColor: color.error,
  buttonPrimaryBackgroundColor: color.brandPrimary,
  buttonPrimaryBackgroundHoverColor: color.brandPrimaryHover,
  buttonPrimaryColor: color.textInverse,
  buttonSecondaryBackgroundColor: color.neutral100,
  buttonSecondaryBackgroundHoverColor: color.surface1,
  buttonSecondaryColor: color.brandPrimary,
  buttonDangerColor: color.error,
  dividerColor: color.textMuted,
  dividerBorderColor: color.blue200,
  progressBackgroundColor: color.neutral300,
  progressColor: color.neutral900,
  tabDefaultColor: color.textSecondary,
  tableHeadBackgroundColor: color.surface1,
  tableHeadColor: color.textSecondary,
  tableLineBorderColor: color.blue200,
  tableLineHoverColor: color.surface1,
  alertErrorBackgroundColor: color.errorBg,
  alertErrorColor: color.error,
  alertWarningBackgroundColor: color.warningBg,
  alertWarningColor: color.warning,
  alertSuccessBackgroundColor: color.successBg,
  alertSuccessColor: color.success,
  switcherColor: color.brandPrimary,
  switcherThumbColor: color.neutral100,
  switcherTrackColor: color.blue300,
  avatarPlaceholderColor: color.textInverse,
  avatarPlaceholderBackgroundColor: color.overlay80,
  countryBackgroundColor: color.surface1,
  checkboxColor: color.brandPrimary,
  checkboxLabelColor: color.textSecondary,
  tooltipColor: color.neutral900,
  pickerActiveBackgroundColor: color.brandPrimary,
  pickerActiveBackgroundHoverColor: color.blue900,
  pickerHoverColor: color.surface1,
};
